// extracted by mini-css-extract-plugin
export default {"modal":"TrendAlertModal_modal__IK12-","content":"TrendAlertModal_content__iVq63","buttonsWrapper":"TrendAlertModal_buttonsWrapper__LD6VQ","tabs":"TrendAlertModal_tabs__t99Se"};